<app-tabla
  [totalCount]="totalCount"
  [datos]="apikeys"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay apikeys' }"
></app-tabla>
